import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Modal } from "reactstrap";

import ConstData from "../../../lib/ConstData";

import Alerts from "../../etc/list/Alerts";

const WebWarningAlertModal = ({ isModalOpened, warningKind, toggleModalOpened }) => {
    const { t } = useTranslation();

    const [lWarningKind, setWarningKind] = useState(warningKind);
    const [lAlertMessage, setAlertMessage] = useState("");
    // const [lAlertKind, setAlertKind] = useState(ConstData.ALERT_KIND.NONE);

    useEffect(() => {
        if (warningKind === "RESET_USER_PW") {
            setAlertMessage(t("관리자_경고_문구_1", { ns: "admin" }));
        } else if (warningKind === "RESET_USER_STATUS") {
            setAlertMessage(t("관리자_경고_문구_2", { ns: "admin" }));
        } else if (warningKind === "SUB_DOMAIN_ADMIN") {
            setAlertMessage(t("관리자_경고_문구_3", { ns: "admin" }));
        } else if (warningKind === "SUB_DOMAIN_CREATE_ADMIN") {
            setAlertMessage(t("관리자_경고_문구_4", { ns: "admin" }));
        } else {
            console.log('WebWarningAlertModal() useEffect warningKind is ', warningKind);
        }
    }, [lWarningKind]);

    const onCloseModal = () => {
        setWarningKind("");
        setAlertMessage("");
        // setAlertKind(ConstData.ALERT_KIND.NONE);
    }

    return (
        // 260805 web-light-modal: 전역 다크 테마 모달 스타일과 분리해 web 화면 톤(라이트)에 맞춤 - index.css의 --modal-* 변수를 라이트 값으로 재정의
        <Modal isOpen={isModalOpened} centered backdrop={true} onClosed={onCloseModal} className="web-light-modal">
            <div className="card container-fluid">
                <div className="card-body">
                    <div className="title-area text-center dark-grey-text">
                        ※ {t("경고", { ns: "admin" })} ※
                    </div>
                    <div className="content-area white dark-grey-text m-0">
                        <Alerts kind={ConstData.ALERT_KIND.DANGER} message={lAlertMessage} />
                    </div>
                    <button type="button" className="btn green white-text py-1 px-2" onClick={() => toggleModalOpened(false)}>{t("확인", { ns: "common" })}</button>
                </div>
            </div>
        </Modal>
    );
}

export default WebWarningAlertModal;